module.exports = __webpack_public_path__ + "img/icon_more.d8ca0c49.svg";